import http from "plugins/axios";

export default {
  getOrderList({ page, size, coin, type,  userId ,startTime,endTime}) {
    return http.get({
      url: `/la/admin/finance/bill/list?page=${page}&size=${size}&coin=${coin}&type=${type}&userId=${userId}&startTime=${startTime}&endTime=${endTime}`,
    });
  },
  exportExcel({  coin, type,  userId ,startTime,endTime}){
    return http.get({
        url: `/la/admin/finance/bill/list/excel?coin=${coin}&type=${type}&userId=${userId}&startTime=${startTime}&endTime=${endTime}`,
        responseType:'blob',
    })
  },
  getFbsPairs(){
    return http.get({
      url:'admin/symbol/fbsNames' //更改后的路径
      // url:' /la/admin/pair/list'
    })
   },
   getAllCoins() {
    return http.get({
      url: '/la/admin/coin/coin-list'
    });
  },
   getAllTypes() {
    return http.get({
      url: '/la/admin/bill/type/all'
    });
  },
};
